export function LogoMark({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <rect width="64" height="64" rx="14" fill="#0B0A10" stroke="#FF7A00" strokeWidth="2.5" />
      <path
        d="M32 10c-10 0-16 8-16 18v22l6-5 5 5 5-5 5 5 5-5 6 5V28c0-10-6-18-16-18z"
        fill="#FFF7EE"
      />
      <circle cx="26" cy="30" r="3.4" fill="#FF7A00" />
      <circle cx="38" cy="30" r="3.4" fill="#FF7A00" />
      <path d="M28 37c2.5 2.5 5.5 2.5 8 0" stroke="#FF7A00" strokeWidth="2.5" fill="none" strokeLinecap="round" />
      <path d="M44 14l8 8-20 20-7 2 2-7z" fill="#39FF14" />
    </svg>
  );
}

export default function Logo({ compact = false }) {
  return (
    <span className="flex items-center gap-3">
      <LogoMark size={compact ? 34 : 42} />
      {!compact && (
        <span className="leading-none">
          <span className="font-display text-2xl text-pumpkin text-glow-orange">Boo Scribbles</span>
          <span className="block text-[10px] font-semibold uppercase tracking-[0.35em] text-slime text-glow-slime">
            Coloring World
          </span>
        </span>
      )}
    </span>
  );
}
